import useAccountData from 'hooks/useAccountData';
import { AccessLevel } from 'models/Company';
import React, { createContext, useContext, useState } from 'react';

const ConfigPermissionContext = createContext<ConfigPermissionContextType | undefined>(undefined);



interface ConfigPermissionContextType {
  configPermissions: { [id: string]: boolean }; // id → canConfig
  fetchConfigPermissions: (id: string) => void;
  canConfig: (id: string) => boolean;
}


export const ConfigPermissionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [configPermissions, setConfigPermissions] = useState<{ [id: string]: boolean }>({});

  const { getCurrentCompany } = useAccountData();
  
    const fetchConfigPermissions = async (companyId: string) => {

      if (configPermissions[companyId] !== undefined) return;

      const company = await getCurrentCompany(companyId);

      if (company === null || company === undefined) {
        setConfigPermissions(prev => ({
          ...prev,
          [companyId]: false,
        }));
      }
      else {     
          setConfigPermissions(prev => ({
          ...prev,
              [companyId]: company.accessRoles.some(x => x === AccessLevel.Role || x === AccessLevel.External),
        }));
      }
    };

  const canConfig = (id: string) => {
    return !!configPermissions[id];
  };
  

  return (
    <ConfigPermissionContext.Provider value={{ configPermissions, canConfig, fetchConfigPermissions }}>
      {children}
    </ConfigPermissionContext.Provider>
  );
};


export const useConfigPermission = () => {
  const context = useContext(ConfigPermissionContext);
  if (!context) {
    throw new Error('useConfigPermission must be used within a ConfigPermissionProvider');
  }
  return context;
};

